export default function preciseDecimal(decimal: number): number {
  return parseFloat(Number(decimal).toFixed(2));
}
